<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    base-modal#help-modal( :show='popup.help' )
      modal-wrapper.max( @close='close' )
        template( v-slot:header )
          h4 {{ $t(helptopic) }}
        template( v-slot:contents )
          help-body(:title = 'helptopic')
          

    template(v-slot:header)
      bf-header(title='Help Center')
    #help-center.view.with-header
      bf-wrapper
        h3 {{$t("Help Center")}}
        bf-input
          input(type='search' :placeholder='$t("How can we help")')
      section.helplist
        .icons
          span( v-for='c, i in helpcats' @click='current.helpcat = i' :alt='c.title')
            img.helpcat(:src='i==current.helpcat? c.icon: c.icon2')
            p.active(v-if='current.helpcat==i') {{ $t(c.title) }}
            p(v-else) {{ $t(c.title) }}
        .swappable
          span( v-for='d in helpcats[current.helpcat].detail') 
            bf-flex.actionable( @click.native='showhelp(d)' ) 
              span {{ $t(d) }}
              
</template>

<script>
  import { View } from '@/mixins/view'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import HelpBody from '@/components/modals/help-body'
    
  export default {
    name: 'help-center.view',
    
    mixins: [View],

    components: {
      BaseModal,
      ModalWrapper,
      HelpBody
    },

    data() {
      return {
        helpcats: [
          {icon: '/ui/getting_start.svg', icon2: '/ui/getting_start2.svg', title: 'Getting Start', detail: 
            [ 'What is BlueFaucet', 'How much does it cost', 'Who needs BlueFaucet', 'How to make a reservation', 'Who can become a merchant' ]
          },  
          {icon: '/ui/manage_account.svg', icon2: '/ui/manage_account2.svg', title: 'Manage Account', detail:
            [ 'Customer Services', 'How does the Invitation work']},
          {icon: '/ui/merchant_function.svg', icon2: '/ui/merchant_function2.svg', title: 'Merchant Function', detail:
            [ 'How do I offer my service', 'How to invite customers to join my membership', 'How does BlueFaucet drive more business for merchants']},
          {icon: '/ui/referral_sales.svg', icon2: '/ui/referral_sales2.svg', title: 'Referral/Sales', detail:
            [ 'What is the BlueFaucet Sales Program', 'What should I do if I did not find my favorite store in the list', 'Referral Program', 'What is Sales job function']}
        ],
        current: { helpcat: 0 },
        popup: { help: false },
      }
    },

    methods: {
      close() {
        this.popup.help = false
      },

      showhelp( topic ) {
        this.helptopic = topic
        this.helpdetail = topic + '-detail'
        this.popup.help = true
      }
    }

  }

</script>
<style scoped lang='stylus'>
  #help-center.view
    text-align justify
    line-height 1.5

  .detail
    line-height 2
    font-size 1.1em

  .helplist
    max-width 1180px
    margin auto
    .active
      color black 
      font-weight bold
    .icons
      background lightgray
      display grid
      grid-template-columns 1fr 1fr 1fr 1fr
      padding-top 20px
      padding-bottom 10px
      text-align center
    .helpcat 
      background lightblue
      padding 10px
      margin 0px 20px 0px 20px
      cursor pointer
      width 100px
      @media(max-width: 480px)
        padding 0px
        margin 0px 5px 0px 5px
        width 70px
    .swappable
      display grid
      grid-template-columns 1fr 1fr
      background white
      opacity 1
      padding 20px
      text-align left
      font-size 1.3em
      line-height 30px
      @media(max-width: 480px)
        grid-template-columns 1fr
        
      
</style>

